var React = require('react');

function Award (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 9.33301C10.2091 9.33301 12 7.54215 12 5.33301C12 3.12387 10.2091 1.33301 8 1.33301C5.79086 1.33301 4 3.12387 4 5.33301C4 7.54215 5.79086 9.33301 8 9.33301Z","stroke":"#666666","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.3193 8.59277L11.3346 14.6661L8.0013 12.6661L4.66797 14.6661L5.6833 8.59277","stroke":"#666666","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Award.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Award;

Award.default = Award;
